module.exports = __webpack_public_path__ + "media/images/recruit_banner-5c96defb9f2a42f9af7a5fbff25c26b7.jpg";